import { useEffect, useState } from "react";
import HandlerRadio from "components/CustomRadio/CustomRadio";
import { Column, Row } from "components/styles";
import { TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import { RADIO_BOOL_OPTIONS } from "../Popups/AppointmentData/utils/constants";
import CustomButton from "components/CustomButton/CustomButton";
import {
    requestCreateAdvisorSession,
    requestTakeAttendance,
    requestUpdateAdvisorSession
} from "services/employability";
import Preloader from "components/Preloader/Preloader";
import { CUSTOM_BUTTON_PROPS } from "views/components/AttendanceList/TakeTeacherAttendancePanel/constants";
import DatePicker from "components/DatePicker/DatePicker";
import useMainContext from "utils/context/useMainContext";
import useScheduleComponentContext from "../../../SchedulesComponent/utils/context/useScheduleComponentContext";

const FINAL_STATES = ["Atendida", "NoAsistio", "Cancelada", "Cerrada"];

const minutesToTime = minutes => {
    const hour = Math.floor(minutes / 60).toString().padStart(2, "0");
    const minute = (minutes % 60).toString().padStart(2, "0");
    return `${hour}:${minute}:00`;
};

const millisToTime = (millis, fallbackMinutes) => {
    if (!millis) return minutesToTime(fallbackMinutes);
    const date = new Date(millis);
    const hour = date.getHours().toString().padStart(2, "0");
    const minute = date.getMinutes().toString().padStart(2, "0");
    return `${hour}:${minute}:00`;
};

const timeToMillis = (dateMillis, time) => {
    const [hour, minute, second = "0"] = time.split(":").map(Number);
    const date = new Date(dateMillis);
    date.setHours(hour, minute, second, 0);
    return date.getTime();
};

const SessionAppointment = ({ reservation, reservationDate, reloadData }) => {
    const mainContext = useMainContext();
    const { changeReservationAttendance } = useScheduleComponentContext();
    const [loading, setLoading] = useState(false);
    const [checkOptionAttendance, setCheckOptionAttendance] = useState(null);
    const [checkIn, setCheckIn] = useState(null);
    const [checkOut, setCheckOut] = useState(null);
    const [errorOptionAttendance, setErrorOptionAttendance] = useState(false);
    const [timeError, setTimeError] = useState("");
    const [currentSession, setCurrentSession] = useState(reservation.session);

    useEffect(() => {
        const session = reservation.session;
        setCurrentSession(session);
        setCheckOptionAttendance(reservation.attended);
        setCheckIn(millisToTime(
            session?.horaInicioReal,
            reservation.timeStart
        ));
        setCheckOut(millisToTime(
            session?.horaFinReal,
            reservation.timeEnd
        ));
        setErrorOptionAttendance(false);
        setTimeError("");
    }, [reservation]);

    const handleCheckOptionAttendance = (value) => {
        setErrorOptionAttendance(false);
        setCheckOptionAttendance(value);
    }

    const saveSession = async () => {
        const actualStart = checkIn
            ? timeToMillis(reservationDate, checkIn)
            : null;
        const actualEnd = checkOut
            ? timeToMillis(reservationDate, checkOut)
            : null;
        const invalidAttendance = checkOptionAttendance === null;
        const invalidTimes = !actualStart || !actualEnd || actualEnd <= actualStart;

        setErrorOptionAttendance(invalidAttendance);
        setTimeError(
            !actualStart || !actualEnd
                ? "La hora de entrada y salida son obligatorias."
                : actualEnd <= actualStart
                    ? "La hora de salida debe ser mayor que la hora de entrada."
                    : ""
        );

        if (invalidAttendance || invalidTimes) {
            return;
        }

        setLoading(true);
        const attendanceSaved = await requestTakeAttendance(
            reservation.id,
            checkOptionAttendance
        );
        if (!attendanceSaved) {
            setLoading(false);
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }

        const sessionPayload = { actualStart, actualEnd };
        const sessionResponse = currentSession?.idSesion
            ? await requestUpdateAdvisorSession(
                reservation.id,
                currentSession.idSesion,
                sessionPayload
            )
            : await requestCreateAdvisorSession(
                reservation.id,
                sessionPayload
            );

        if (!sessionResponse) {
            setLoading(false);
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }

        const savedSession = sessionResponse.sesion || sessionResponse;
        setCurrentSession(savedSession);
        changeReservationAttendance(reservation.id, checkOptionAttendance);
        if (reloadData) await reloadData();
        setLoading(false);
    }

    const isFinalState = FINAL_STATES.includes(reservation.state);

    return (
        <Column marginTop="6px">
            <Row width="100%" gap="15px" wrap="nowrap">
                <div style={{ flex: 1 }}>
                    <DatePicker
                        textData="Hora de entrada:"
                        value={checkIn}
                        setValue={setCheckIn}
                    />
                </div>
                <div style={{ flex: 1 }}>
                    <DatePicker
                        textData="Hora de salida:"
                        value={checkOut}
                        setValue={setCheckOut}
                    />
                </div>
            </Row>
            {timeError &&
                <TextData style={{ color: "#d32f2f" }}>{timeError}</TextData>}

            <Row justifyContent="flex-start" width="100%">
                <div>
                    <TextData>¿Asistió el estudiante?</TextData>
                    <HandlerRadio 
                        radiosProps={RADIO_BOOL_OPTIONS}
                        value={checkOptionAttendance}
                        onChange={handleCheckOptionAttendance}
                        gap='35px'
                        error={errorOptionAttendance}
                        errorText={errorOptionAttendance && "Seleccionar opción"}
                        marginTop="8px"/>
                </div>
            </Row>

            <CustomButton
                {...CUSTOM_BUTTON_PROPS}
                size="medium"
                width="83px"
                text="Guardar"
                onClick={saveSession}
                disabled={loading || isFinalState}
            />

            <Preloader
                hidden={!loading}
                message="Guardando atención..."/>
        </Column>
    )
}

export default SessionAppointment;
